import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import React from 'react';
import { ILinkList, ITemplateData } from '@/services/template-data-service';

export default function LinkNavigation({ templateData }: { templateData: ITemplateData }) {
  const LinkNavigationCol = ({ linkList }: { linkList: ILinkList }) => (
    <Col md={4} lg={3}>
      <h3>{linkList.title}</h3>
      <ul className="pl-3">
        {linkList.items.map((item, j) => (
          <Row key={j}>
            <li>
              <a href={item.href}>{item.text}</a>
            </li>
          </Row>
        ))}
      </ul>
    </Col>
  );

  return (
    <>
      <LinkNavigationCol linkList={templateData.footer.overOns} />
      <LinkNavigationCol linkList={templateData.footer.klantenService} />
      <LinkNavigationCol linkList={templateData.footer.actueel} />
    </>
  );
}
